export const memberConstants = {
  MEMBER_INFO: "MEMBER_INFO",
  MEMBER_ERROR: "MEMBER_ERROR",
  ACCOUNT_INFO: "ACCOUNT_INFO",
  MEMBERS_INFO: "MEMBERS_INFO",
  MEMBERS_INFO_REQUEST: "MEMBERS_INFO_REQUEST",
  MEMBERS_INFO_SUCCESS: "MEMBERS_INFO_SUCCESS",
  MEMBER_NUMBER: "MEMBER_NUMBER",
  AGENT_INFO: "AGENT_INFO",
  DRAW_DETAIL: "DRAW_DETAIL",
  FREEZE_DETAIL: "FREEZE_DETAIL",
  HIDE_DRAW_MODAL: "HIDE_DRAW_MODAL",
  HIDE_FREEZE_MODAL: "HIDE_FREEZE_MODAL",
  DOCUMENT_FILE: "DOCUMENT_FILE",
  DOCUMENT_LINK: "DOCUMENT_FILE",
  CONTROL_MEMBER_REQUEST: "CONTROL_MEMBER_REQUEST",
  CONTROL_MEMBER_SUCCESS: "CONTROL_MEMBER_SUCCESS",
  SAVE_MEMBER_REQUEST: "SAVE_MEMBER_REQUEST",
  SAVE_MEMBER_SUCCESS: "SAVE_MEMBER_SUCCESS",
  RESEND_SMS_NEW_MEMBER_REQUEST: "RESEND_SMS_NEW_MEMBER_REQUEST",
  RESEND_SMS_NEW_MEMBER_SUCCESS: "RESEND_SMS_NEW_MEMBER_SUCCESS",
  SEND_NEW_MEMBER_ADDRESS: "SEND_NEW_MEMBER_ADDRESS",
  CLEAR_NEW_MEMBER_REDIRECT: "CLEAR_NEW_MEMBER_REDIRECT",
  CLEAR_NEW_MEMBER_DONE: "CLEAR_NEW_MEMBER_DONE",
  CONTROL_CARD_CONTACT_INFO_REQUEST: "CONTROL_CARD_CONTACT_INFO_REQUEST",
  CONTROL_CARD_CONTACT_INFO_SUCCESS: "CONTROL_CARD_CONTACT_INFO_SUCCESS",
  SAVE_CARD_CONTACT_INFO_REQUEST: "SAVE_CARD_CONTACT_INFO_REQUEST",
  SAVE_CARD_CONTACT_INFO_SUCCESS: "SAVE_CARD_CONTACT_INFO_SUCCESS",
  RESEND_VALIDATECODE_CONTACT_INFO_REQUEST: "RESEND_VALIDATECODE_CONTACT_INFO_REQUEST",
  RESEND_VALIDATECODE_CONTACT_INFO_SUCCESS: "RESEND_VALIDATECODE_CONTACT_INFO_SUCCESS",
  CLEAR_CONTACT_INFO_REDIRECT: "CLEAR_CONTACT_INFO_REDIRECT",
  EXPENSE_BY_MEMBER_NO_SUCCESS:"EXPENSE_BY_MEMBER_NO_SUCCESS",
  EXPENSE_BY_MEMBER_NO_REQUEST:"EXPENSE_BY_MEMBER_NO_REQUEST"
};
